// extracted by mini-css-extract-plugin
export default {"priceNote":"AddPriceModal_priceNote__n+g7H","price":"AddPriceModal_price__MjPRB"};